import React from 'react';
import SidebarTransition from './SidebarTransition';
import { useSidebarTab } from '../contexts/SidebarTabContext';
import { useUser } from '../contexts/UserContext';

export default function SidebarTransitionWrapper({ onSidebarVisible }) {
  const { activeTab, setActiveTab } = useSidebarTab();
  const { user } = useUser();
  const userRole = user?.rol || 'usuario';
  return <SidebarTransition activeTab={activeTab} setActiveTab={setActiveTab} userRole={userRole} onSidebarVisible={onSidebarVisible} />;
}
